import { render, staticRenderFns } from "./mudancaClasse.vue?vue&type=template&id=790454fc&"
import script from "./mudancaClasse.vue?vue&type=script&lang=js&"
export * from "./mudancaClasse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports